import clsx from 'clsx';
import { ReactNode, useMemo } from 'react';

import { getOverlayAlignment, getOverlayRespectOverflow, getOverlayVerticalAligment } from '../ModuleOverrides';
import styles from './ModuleEditMenu.module.css';

type ModuleEditMenuProps = {
  children: ReactNode;
  show: boolean;
  title: string;
};
export const ModuleEditMenu = ({ title, show, children }: ModuleEditMenuProps) => {
  const clsPosition = useMemo(() => {
    const align = getOverlayAlignment(title);
    const verticalAlign = getOverlayVerticalAligment(title);
    return clsx(
      'module-edit-menu-positioner',
      styles.menuPosition,
      getOverlayRespectOverflow(title) && styles.menuRespectOverflow,
      {
        [styles.menuVerticalTop]: verticalAlign === 'top',
        [styles.menuVerticalDefault]: verticalAlign === 'default',
      },
      {
        [styles.menuLeft]: align === 'left',
        [styles.menuRight]: align === 'right',
        [styles.menuCenter]: align === 'center',
      },
    );
  }, [title]);
  const clsMenu = clsx('module-edit-menu', styles.moduleMenu, show && styles.menuShow);
  return (
    <div className={clsPosition}>
      <div className={clsMenu}>{children}</div>
    </div>
  );
};
